import { useNavigate, useLocation } from 'react-router-dom';
import { BookOpen, Users, Newspaper, Search, User } from 'lucide-react';
import { useArticlesStore, useFeedsStore } from '../store/useStore';

interface MobileBottomNavProps {
  onSearch: () => void;
}

export default function MobileBottomNav({ onSearch }: MobileBottomNavProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const setFilter = useArticlesStore((state) => state.setFilter);
  const setBucket = useArticlesStore((state) => state.setBucket);
  const setSelectedFeedId = useFeedsStore((state) => state.setSelectedFeedId);
  const setSelectedFolderId = useFeedsStore((state) => state.setSelectedFolderId);

  const path = location.pathname;

  const items = [
    {
      label: 'Read',
      icon: BookOpen,
      active: path === '/read' || path.startsWith('/article/'),
      onClick: () => {
        setFilter('unread');
        setBucket('today');
        setSelectedFeedId(null);
        setSelectedFolderId(null);
        navigate('/read');
      },
    },
    {
      label: 'Friends',
      icon: Users,
      active: path === '/friends',
      onClick: () => navigate('/friends'),
    },
    {
      label: 'Digest',
      icon: Newspaper,
      active: path.startsWith('/digest'),
      onClick: () => navigate('/digest'),
    },
    {
      label: 'Search',
      icon: Search,
      active: false,
      onClick: onSearch,
    },
    {
      label: 'Me',
      icon: User,
      active: path.startsWith('/settings') || path.startsWith('/users') || path.startsWith('/user/'),
      onClick: () => navigate('/settings'),
    },
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 bg-canvas border-t border-edge z-40 safe-area-bottom">
      <div className="flex items-stretch h-14">
        {items.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.label}
              onClick={item.onClick}
              className={`flex flex-col items-center justify-center flex-1 min-w-0 gap-1 border-r border-edge last:border-r-0 ${
                item.active ? 'bg-ink text-canvas' : 'text-ink-secondary'
              }`}
            >
              <Icon className="w-5 h-5" strokeWidth={1.75} />
              <span className="kicker" style={{ color: 'inherit' }}>{item.label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
